import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  subtitle: {
    fontSize: "1.8rem",
    marginBottom: theme.spacing(2),
  },
  formHelperText: {
    marginLeft: "0px",
    position: "absolute",
    bottom: "-20px",
  },
  inputBackgroundColor: {
    backgroundColor: "#F8F8F8",
  },
}))

export default styles
